import { NetworkUtils } from '../../utils/networks.utils'
import { InventoryCheckApi } from '../../api/inventoryChecks.api'
import { FilesApi } from '../../api/files.api'
import {
  InventoryCheckWaste,
  InventoryCheckWastePagination,
  ReusedResourcePagination,
} from '../../models/inventoryChecks.model'

export class InventoryChecksService {
  createWaste = async (
    data: InventoryCheckWaste,
    // At least one supporting document file is required when creating a waste
    files: File[],
  ): Promise<InventoryCheckWaste> => {
    await NetworkUtils.checkConnected()

    const uploadedDocs = await Promise.all(files.map((file) => FilesApi.create(file)))

    const dataParse = {
      ...data,
      sortedOnWorkingSite: data.sortedOnWorkingSite === 'true',
      supportingDocuments: [...data.supportingDocuments, ...uploadedDocs],
    }

    return await InventoryCheckApi.createWaste(dataParse)
  }

  updateWaste = async (
    id: string,
    data: InventoryCheckWaste,
    files?: File[],
  ): Promise<InventoryCheckWaste> => {
    await NetworkUtils.checkConnected()

    const uploadedDocs = files
      ? await Promise.all(files.map((file) => FilesApi.create(file)))
      : []

    const dataParse = {
      ...data,
      sortedOnWorkingSite: data.sortedOnWorkingSite === 'true',
      supportingDocuments: [...data.supportingDocuments, ...uploadedDocs],
    }

    return await InventoryCheckApi.updateWaste(id, dataParse)
  }

  deleteWaste = async (id: string): Promise<void> => {
    await NetworkUtils.checkConnected()
    return await InventoryCheckApi.deleteWaste(id)
  }

  getListWastes = async (
    params: InventoryCheckApi.GetListParams,
  ): Promise<InventoryCheckWastePagination> => {
    await NetworkUtils.checkConnected()
    return await InventoryCheckApi.getListWastes(params)
  }

  getListResources = async (
    params: InventoryCheckApi.GetListParams,
  ): Promise<ReusedResourcePagination> => {
    await NetworkUtils.checkConnected()
    return await InventoryCheckApi.getListReusedResources(params)
  }
}

export const inventoryChecksService = new InventoryChecksService()
